import {
  GET_SKILLS, GET_SKILLS_REQUEST, GET_SKILLS_ERROR, SET_SKILLS,
  GET_ARTIST_TYPES, GET_ARTIST_TYPES_REQUEST, GET_ARTIST_TYPES_ERROR, SET_ARTIST_TYPES,
  GET_JOB_ADS, JOB_ADS_REQUEST, JOB_ADS_SUCCESS, JOB_ADS_ERROR
} from "../actions/skillsConst";
import axios from 'axios'
import {BehaviorSubject} from 'rxjs'

const state = {
  skillsApi: (process.env.VUE_APP_USTAGE_API || 'http://localhost:3000/api')+'/Skills',
  artistTypesApi: (process.env.VUE_APP_USTAGE_API || 'http://localhost:3000/api')+'/ArtistTypes',
  // jobAdsApi: process.env.VUE_APP_JOB_ADS_API || 'https://universtage.com/jobAdsRest/rest/searchAdvert/getAndSendAdsBySkill',
  skills: [],
  artistTypes: [],
  statusJobAds: '',
  isLoadingSkills: false,
  isLoadingArtistTypes: false,
  RxIsLoadSkills: new BehaviorSubject(null),
  RxIsLoadArtistTypes: new BehaviorSubject(null),
}

const getters = {
  getSkills: state => state.skills,
  getArtistTypes: state => state.artistTypes,
  RxIsLoadSkills: state => state.RxIsLoadSkills,
  RxIsLoadArtistTypes: state => state.RxIsLoadArtistTypes,
  isLoadingJobAds: state => state.statusJobAds==='loading',
  isLoadingSkills: state => state.isLoadingSkills,
  isLoadingArtistTypes: state => state.isLoadingArtistTypes,
}

const actions = {
  [GET_SKILLS]: ({commit}) => {
    return new Promise((resolve, reject) => {
      if(state.skills.length) {
        commit(SET_SKILLS, state.skills)
        resolve('Skill load successfull')
      } else {
        commit(GET_SKILLS_REQUEST)
        axios.get(state.skillsApi)
          .then(res=>res.data)
          .then(res=>{
            commit(SET_SKILLS, res)
            resolve('Skill load successfull')
          })
          .catch(err=>{
            commit(GET_SKILLS_ERROR)
            reject(err)
          })
      }
    })
  },
  [GET_ARTIST_TYPES]: ({commit}) => {
    return new Promise((resolve, reject) => {
      if(state.artistTypes.length) {
        commit(SET_ARTIST_TYPES, state.artistTypes)
        resolve('Artist types load successfull')
      } else {
        commit(GET_ARTIST_TYPES_REQUEST)
        axios.get(state.artistTypesApi)
          .then(res=>res.data)
          .then(res=>{
            commit(SET_ARTIST_TYPES, res)
            resolve('Artist types load successfull')
          })
          .catch(err=>{
            commit(GET_ARTIST_TYPES_ERROR)
            reject(err)
          })
      }
    })
  },
  [GET_JOB_ADS]: ({commit}, query) => {
    return new Promise((resolve, reject) => {
      commit(JOB_ADS_REQUEST)
      axios.post(state.skillsApi + '/jobAdsRest', {data: query})
        .then(res=>res.data)
        .then(res=>{
          commit(JOB_ADS_SUCCESS)
          resolve(res)
        })
        .catch(err=>{
          commit(JOB_ADS_ERROR)
          reject(err)
        })
    })
  },
}

const mutations = {
  [JOB_ADS_REQUEST]: (state) => {
    state.statusJobAds = 'loading'
  },
  [JOB_ADS_SUCCESS]: (state) => {
    state.statusJobAds = 'success'
  },
  [JOB_ADS_ERROR]: (state) => {
    state.statusJobAds = 'error'
  },
  [GET_SKILLS_REQUEST]: (state) => {
    state.isLoadingSkills = true
  },
  [GET_SKILLS_ERROR]: (state) => {
    state.isLoadingSkills = false
  },
  [SET_SKILLS]: (state, skills) => {
    state.skills = skills
    state.isLoadingSkills = false
    state.RxIsLoadSkills.next(state.skills)
  },
  [GET_ARTIST_TYPES_REQUEST]: (state) => {
    state.isLoadingArtistTypes = true
  },
  [GET_ARTIST_TYPES_ERROR]: (state) => {
    state.isLoadingArtistTypes = false
  },
  [SET_ARTIST_TYPES]: (state, types) => {
    state.artistTypes = types
    state.isLoadingArtistTypes = false
    state.RxIsLoadArtistTypes.next(state.artistTypes)
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
